import { IRoute } from './';

import AccountScreen from '../screens/Account/Account';
import DashboardScreen from '../screens/Dashboard/Dashboard';
import FeedbackScreen from '../screens/Feedback/Feedback';
import JobDetailScreen from '../screens/Jobs/JobDetail/JobDetail';
import JobsScreen from '../screens/Jobs/Jobs';
import ReviewsScreen from '../screens/Reviews/Reviews';
import UserDetailScreen from '../screens/Users/UserDetail/UserDetail';
import UsersScreen from '../screens/Users/Users';

const adminRoutes: IRoute[] = [
  {
    path: '/account',
    exact: true,
    component: AccountScreen,
  },
  {
    path: '/',
    exact: true,
    component: DashboardScreen,
  },
  {
    path: '/feedback',
    exact: true,
    component: FeedbackScreen,
  },
  {
    path: '/jobs',
    exact: true,
    component: JobsScreen,
  },
  {
    path: '/jobs/:jobId',
    exact: true,
    component: JobDetailScreen,
  },
  {
    path: '/reviews',
    exact: true,
    component: ReviewsScreen,
  },
  {
    path: '/users',
    exact: true,
    component: UsersScreen,
  },
  {
    path: '/users/:userId',
    exact: true,
    component: UserDetailScreen,
  },
];

export default adminRoutes;



// WEBPACK FOOTER //
// ./src/routes/admin.ts